import CheckboxField from '@rewardopl/react-ui/checkbox_field';

type MarketingControlsProps = {
  form?: string;
  marketingEmailAccepted: boolean;
  marketingProfilingAccepted: boolean;
  marketingSmsAccepted: boolean;
  setMarketingEmailAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  setMarketingProfilingAccepted: React.Dispatch<React.SetStateAction<boolean>>;
  setMarketingSmsAccepted: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function MarketingControls({
  form,
  marketingEmailAccepted,
  marketingProfilingAccepted,
  marketingSmsAccepted,
  setMarketingEmailAccepted,
  setMarketingProfilingAccepted,
  setMarketingSmsAccepted,
}: MarketingControlsProps) {
  return (
    <>
      <CheckboxField
        checked={marketingSmsAccepted}
        form={form}
        label="SMS communication"
        name="marketing_sms_accepted"
        onChange={() => {
          setMarketingSmsAccepted(!marketingSmsAccepted);
        }}
        required={false}
      />
      <CheckboxField
        checked={marketingEmailAccepted}
        form={form}
        label="e-mail communication"
        name="marketing_email_accepted"
        onChange={() => {
          setMarketingEmailAccepted(!marketingEmailAccepted);
        }}
        required={false}
      />
      <CheckboxField
        checked={marketingProfilingAccepted}
        form={form}
        label="profiling to receive the best-suited offers"
        name="marketing_profiling_accepted"
        onChange={() => {
          setMarketingProfilingAccepted(!marketingProfilingAccepted);
        }}
        required={false}
      />
    </>
  );
}
